var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82174 4.72239C2.19146 4.01796 1.87631 3.66574 1.86443 3.3664C1.8541 3.10636 1.96585 2.85643 2.16652 2.69074C2.39753 2.5 2.87015 2.5 3.8154 2.5H16.1845C17.1298 2.5 17.6024 2.5 17.8334 2.69074C18.0341 2.85643 18.1458 3.10636 18.1355 3.3664C18.1236 3.66574 17.8084 4.01796 17.1782 4.72239L12.423 10.037C12.2973 10.1774 12.2345 10.2477 12.1897 10.3276C12.15 10.3984 12.1208 10.4747 12.1032 10.554C12.0833 10.6435 12.0833 10.7377 12.0833 10.9261V15.382C12.0833 15.5449 12.0833 15.6264 12.057 15.6969C12.0338 15.7591 11.996 15.8149 11.9468 15.8596C11.8912 15.9102 11.8155 15.9404 11.6642 16.001L8.83088 17.1343C8.52459 17.2568 8.37145 17.3181 8.24851 17.2925C8.14101 17.2702 8.04666 17.2063 7.98599 17.1148C7.91662 17.0101 7.91662 16.8452 7.91662 16.5153V10.9261C7.91662 10.7377 7.91662 10.6435 7.89672 10.554C7.87907 10.4747 7.84992 10.3984 7.81019 10.3276C7.7654 10.2477 7.70258 10.1774 7.57694 10.037L2.82174 4.72239Z",
    stroke: "#155B75",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.bc0f7bbdb1a6264a39cc85e86b46e1d0.svg";
export { ForwardRef as ReactComponent };